import actions from '@/core/store/item-pedido/actions'
import state from '@/core/store/item-pedido/state'
import mutations from '@/core/store/item-pedido/mutations'
import estorno from '@/core/store/item-pedido/estorno'

export default {
	actions,
	state,
	mutations,
	modules: {
		estorno,
	},
}
